/* @flow */

import * as React from 'react';
import is from 'is_js';
// import styled from 'styled-components';
// import { NavListItem } from './Nav';

type Props = {
  className?: string,
  keys: Array<string>,
  isOpen?: boolean,
  onMouseLeave: Function,
  component: Function,
  children: Function,
};

class DropdownGoogleTran extends React.PureComponent<Props> {
  _node = React.createRef();

  static defaultProps = {
    className: '',
    keys: [],
    isOpen: false,
    onMouseLeave: () => {},
    component: ({ children }: Function) => children,
    children: () => null,
  };

  componentDidMount() {
    if (is.function(this.props.onMouseLeave)) {
      window.addEventListener('mouseover', this._onHoveredOutside);
      window.addEventListener('touchstart', this._onHoveredOutside);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mouseover', this._onHoveredOutside);
    window.removeEventListener('touchstart', this._onHoveredOutside);
  }

  _onHoveredOutside = (evt: MouseEvent) => {
    if (!this.props.isOpen || !this._node) return;
    if (this._node.current && this._node.current.parentElement.contains(evt.target)) {
      return;
    }
    this.props.onMouseLeave();
  };

  render() {
    const {
      className, keys, isOpen, component: ChildComponent, children,
    } = this.props;
    if (!isOpen || keys.length < 2) return null;
    return (
      <ChildComponent className={className} ref={this._node}>
        {keys.map((key, index) => children({ key, index }))}
      </ChildComponent>
    );
  }
}

export default DropdownGoogleTran;
